/**
 * Carga Cielo
 * @author Simpli CLI generator
 */
import {
  $, HttpBody,
  ID,
  Resource, Resp,
  ResponseSerialize,
} from 'simpli-web-sdk'
import CargaCieloSchema from '@/schema/CargaCielo.schema'
import StatusCarga from '@/model/resource/StatusCarga'
import ChecklistEntrega from '@/model/resource/ChecklistEntrega'
import BarcodeCielo from '@/model/resource/BarcodeCielo'
import {DeliveryStatus} from '@/enums/DeliveryStatus'
import TipoOcorrenciaSucesso from '@/model/resource/TipoOcorrenciaSucesso'

export default class CargaCielo extends Resource {
  readonly $name: string = 'CargaCielo'

  readonly $endpoint: string = '/user/carga{/id}'

  get $schema() {
    return CargaCieloSchema(this)
  }

  $id = 0

  @ResponseSerialize(StatusCarga)
  status: StatusCarga | null = null

  @ResponseSerialize(ChecklistEntrega)
  listChecklistEntrega: ChecklistEntrega[] = []

  @ResponseSerialize(BarcodeCielo)
  listBarcodeCielo: BarcodeCielo[] = []

  @ResponseSerialize(TipoOcorrenciaSucesso)
  tipoOcorrenciaSucesso: TipoOcorrenciaSucesso | null = null

  tipoDeRemessa = 'Prestação de Serviço'

  textoStatusFinal: string | null = null

  codeServiceType: string | null = null // SIGLA

  dataPrevisao: string | null = null
  dataInicioEntrega: string | null = null
  dataFinalizacao: string | null = null

  merchantID: string | null = null // CTE

  referenceCode: string | null = null // NOTA FISCAL

  logicalNumber: string | null = null // VERIFICARE

  legalEntityName: string | null = null // razao social destinatario
  businessName: string | null = null // nome fantasia destinatario

  // Endereço Destinatario
  address: string | null = null
  neighborhood: string | null = null
  city: string | null = null
  state: string | null = null
  addressCode: string | null = null

  fotosComprovantes: string[] = []

  nomeRecebedor: string | null = null
  documentoRecebedor: string | null = null
  rgRecebedor: string | null = null

  get statusCargaTagClass() {
    if (this.status) {
      if (this.status.$id === DeliveryStatus.STARTED) {
        return 'perfume'
      } else if (this.status.$id === DeliveryStatus.PENDING) {
        return 'warning'
      } else if (this.status.$id === DeliveryStatus.FINISHED) {
        return 'aquamarine'
      }
    }
    return 'default'
  }

  async getCargaEspecial(id: ID, hash?: string, spinner = 'getCargaEspecial') {
    const params = {hash}

    const fetch = async () => await this.GET(`/user/carga/getCargaEspecial/${id}`, {params})
    return await $.await.run<Resp<this>>(fetch, spinner)
  }
}
